import Footer from './components/Footer';
import Contacts from './components/Contacts';
import Hero from './components/Hero';
import Nav from './components/Nav';
import logo from './assets/logo.png';
import OurMission from './components/OurMission';

const Landing = () => {
  return (
    <div className="wrapper">
      <header>
        <div className="header-content">
          <div className="logo">
            <img src={logo} alt="Incosys Trading" />
            <div className="logo-text">
              <span>incosys</span>
              <span>trading</span>
            </div>
          </div>
          <Nav />
        </div>
      </header>

      <Hero />
      <OurMission />
      <Contacts />
      <Footer />
    </div>
  );
};

export default Landing;
